import { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DOMPurify from "dompurify";
import { ConfirmModal } from "../../ConfirmModal";
import styles from "./index.module.scss";

interface ActivityFootnoteTooltipProps {
  footnoteList: DPFootnote.FootnoteData[];
  isReadOnly?: boolean;
  onEdit: any;
  onDel: any;
  [name: string]: any;
}

export function ActivityFootnoteTooltip({
  footnoteList,
  isReadOnly,
  onEdit,
  onDel,
  ...res
}: ActivityFootnoteTooltipProps) {
  const [isOpenDelConfirm, setIsOpenDelConfirm] = useState<any>({
    visible: false,
  });

  return (
    <>
      <div className={styles.footnoteTooltipRoot}>
        {footnoteList.map((item: DPFootnote.FootnoteData) => (
          <div className={styles.line} key={item.footnote_id}>
            <div>
              <div className={styles.title}>{item.footnote_type}</div>
              <div
                className={styles.desc}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.footnote_preview_text),
                }}
              ></div>
            </div>
            {!isReadOnly && (
              <div className={styles.icons}>
                <EditOutlined
                  style={{ fontSize: 16, color: "#FFF" }}
                  onClick={() => onEdit(item.footnote_type_id, { ...res })}
                />
                <DeleteOutlined
                  style={{ fontSize: 16, color: "#FFF" }}
                  onClick={() =>
                    setIsOpenDelConfirm({
                      visible: true,
                      footnote_id: item.footnote_id,
                    })
                  }
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <ConfirmModal
        visible={isOpenDelConfirm.visible}
        title={`Delete Footnote`}
        content={`Are you sure you want to delete this footnote?`}
        handleCancel={() => setIsOpenDelConfirm({ visible: false })}
        handleConfirm={() => {
          onDel([isOpenDelConfirm.footnote_id]);
          setIsOpenDelConfirm({ visible: false });
        }}
      />
    </>
  );
}
